export default {
  'movementDirectSale.label.filteByDate': 'Filtrar por data de',
  'movementDirectSale.label.situation': 'Situação',
  'movementDirectSale.label.reportType': 'Selecione o tipo de relatório',
  'movementDirectSale.label.groupReportBy': 'Agrupar relatório por',
  'movementDirectSale.label.customers': 'Clientes',
  'movementDirectSale.label.seller': 'Vendedor',
  'movementDirectSale.label.tags': 'Etiquetas venda direta',
  'movementDirectSale.label.moreOptions': 'Mais Opções',

  'movementDirectSale.option.sale': 'Venda',
  'movementDirectSale.option.authorization': 'Autorização',
  'movementDirectSale.option.cancellation': 'Cancelamento',
  'movementDirectSale.option.createDate': 'Data de Criação',
  'movementDirectSale.option.open': 'Abertos',
  'movementDirectSale.option.authorized': 'Autorizados',
  'movementDirectSale.option.canceled': 'Cancelados',
  'movementDirectSale.option.salesSummary': 'Resumo das Vendas',
  'movementDirectSale.option.totalBySales': 'Total por venda',
  'movementDirectSale.option.seller': 'Vendedor',
  'movementDirectSale.option.situation': 'Situação',
  'movementDirectSale.option.diary': 'Diário',
  'movementDirectSale.option.monthly': 'Mensal',

  'movementDirectSale.checkbox.synthetic': 'Sintético',

  'movementDirectSale.button.selectCustomers': 'Selecionar Clientes',
};
